import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { authInterceptor } from 'svnxii-modules/auth/interceptors';
import { AUTH_CONFIG } from 'svnxii-modules/auth/models';
import { languageInitializerProvider } from 'svnxii-modules/i18n/initializer';
import { languageInterceptor } from 'svnxii-modules/i18n/interceptors';
import { mutationLoadingInterceptor } from 'svnxii-ng-shared/components/global-loader';
import { EnvironmentService } from 'svnxii-ng-shared/services';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json`);
  }
}

export function httpLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

export function environmentFactory() {
  return new EnvironmentService(environment.apiUrl, environment.devFeature);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        languageInterceptor,
        mutationLoadingInterceptor,
      ]),
    ),
    {
      provide: EnvironmentService,
      useFactory: environmentFactory,
    },
    {
      provide: AUTH_CONFIG,
      useValue: {
        dashboard: '/app',
        onboarding: '/onboarding',
      },
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    languageInitializerProvider,
  ],
};
